import { Stack } from "@chakra-ui/react";
import React, { memo, useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import { NodeProps } from "reactflow";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";
import { NodeData, NodeType } from "../../../models/nodeType";
import SelectSfx from "../../base/SelectSfx";
import { FlowNodeWithChildren } from "./FlowNode";

interface PrefetchSfx extends NodeData {
  fileName: string;
}

const PrefetchSfxNode: React.FC<NodeProps<NodeType<PrefetchSfx>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const fileName = nodeData?.fileName ?? "";

  const { register, getValues, setValue, handleSubmit } = useForm<PrefetchSfx>({
    defaultValues: useMemo(
      () => ({
        fileName,
      }),
      [fileName]
    ),
    mode: "onChange",
  });

  const { updateNodeData } = useUpdateNodeData<PrefetchSfx>(nodeId);

  const handleUpdate = useCallback(
    (nodeData: PrefetchSfx) => {
      updateNodeData(nodeData);
    },
    [updateNodeData]
  );

  return (
    <>
      <FlowNodeWithChildren {...props}>
        <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
          <Stack>
            <SelectSfx
              value={getValues("fileName")}
              setValue={(value) => setValue("fileName", value)}
              color={color}
            />
          </Stack>
        </form>
      </FlowNodeWithChildren>
    </>
  );
};

export default memo(PrefetchSfxNode);
